module.exports = __webpack_public_path__ + "img/farzana-christopher-130.58f01924.jpg";